/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-list-bulleted': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M4.375 7.5a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75zm0 8.75a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75zM10 13.75h8.75V15H10v-1.25zM10 5h8.75v1.25H10V5z"/>'
  }
})
